/**
 * Gates checkout entry points behind the "accept terms of trade" checkbox.
 * The checkbox's native `required` + `form` association already blocks the
 * main checkout buttons at the browser level, but express/dynamic checkout
 * buttons (Shop Pay, PayPal, etc.) render their own click handlers outside
 * that form and need this to be blocked at all.
 *
 * Gated buttons stay clickable (no pointer-events: none) so a click while
 * unchecked shows an inline message next to the checkbox instead of doing
 * nothing.
 *
 * Two markup shapes are supported:
 * 1. Self-contained: an ancestor with [data-cart-terms] containing
 *    [data-cart-terms-checkbox], an optional [data-cart-terms-message], and
 *    one or more [data-requires-terms-accept] elements.
 * 2. Standalone (e.g. the sticky add-to-cart bar, which has no room for its
 *    own checkbox): a [data-requires-terms-accept] with no [data-cart-terms]
 *    ancestor falls back to the first [data-cart-terms-checkbox] on the page
 *    (the main product form's checkbox and its message).
 *
 * Cart drawer/page content is replaced wholesale (innerHTML) after every
 * quantity change, which would silently drop these bindings on the fresh
 * DOM — so re-init runs on the theme's `cart:updated` event too.
 */
(function () {
  function bind(checkbox, gated) {
    if (!checkbox || !gated || gated.dataset.termsBound) return;
    gated.dataset.termsBound = 'true';

    var container = checkbox.closest('[data-cart-terms]') || document;
    var message = container.querySelector('[data-cart-terms-message]');

    function sync() {
      var accepted = checkbox.checked;
      gated.style.opacity = accepted ? '' : '0.7';
      gated.setAttribute('aria-disabled', accepted ? 'false' : 'true');
      if (accepted && message) message.hidden = true;
    }

    sync();
    checkbox.addEventListener('change', sync);

    gated.addEventListener(
      'click',
      function (event) {
        if (!checkbox.checked) {
          event.preventDefault();
          event.stopPropagation();

          if (message) {
            message.hidden = false;
            message.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          checkbox.focus();
        }
      },
      true
    );
  }

  function init(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-cart-terms]').forEach(function (container) {
      var checkbox = container.querySelector('[data-cart-terms-checkbox]');
      container.querySelectorAll('[data-requires-terms-accept]').forEach(function (gated) {
        bind(checkbox, gated);
      });
    });

    document.querySelectorAll('[data-requires-terms-accept]:not([data-terms-bound])').forEach(function (gated) {
      if (gated.closest('[data-cart-terms]')) return;
      bind(document.querySelector('[data-cart-terms-checkbox]'), gated);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('cart:updated', function () {
    init(document);
  });
})();
